import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {
  ClientNotificationService
} from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs.service';
import {ClientNotification} from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs';
import {trackEntityById} from 'projects/core/src/public-api';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {User} from 'projects/core/src/lib/login/data/user';
import {MatDialog} from '@angular/material/dialog';
import {CreateMessageDialogComponent} from './create-message-dialog/create-message-dialog.component';
import {UserService} from 'projects/core/src/lib/login/data/user.service';

@Component({
  selector: 'app-client-messages-block',
  templateUrl: './client-messages-block.component.html',
  styleUrls: ['./client-messages-block.component.scss']
})
export class ClientMessagesBlockComponent implements OnInit, OnDestroy {

  @Input()
  projectId: number;

  clientNfs: ClientNotification[];

  msgLoading = false;

  trackEntityById = trackEntityById;

  isMobile: boolean;

  currentUser: User;

  showClientNfs: boolean;

  constructor(
    protected clientNotificationService: ClientNotificationService,
    protected deviceDetectorService: DeviceDetectorService,
    protected userService: UserService,
    protected appStateQuery: AppStateQuery,
    protected dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.isMobile = this.deviceDetectorService.isMobile();
    this.getCurrentUser();
  }

  getCurrentUser() {
    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user;

      this.appStateQuery.rolesAccessMap$.subscribe(accessMap => {

        let tempSet: Set<string>
        if (accessMap.has('/client-nfs')) {
          tempSet = new Set(accessMap.get('/client-nfs'))

          this.currentUser.roles.forEach(role => {
            if (tempSet.has(role.name)) {
              this.showClientNfs = true
            }
          })
        }

        if (!this.showClientNfs) {
          this.userService.getProjectManagers().subscribe(users => {
            this.showClientNfs = !!users.find(usr => usr.id === this.currentUser.id);
          })
        }
      })

    })
  }

  loadMsgs() {
    this.msgLoading = true;
    this.getMessages();
  }

  getMessages() {
    this.clientNotificationService.getClientNfsForProject(this.projectId).subscribe(msgs => {
      this.clientNfs = msgs;
      this.msgLoading = false;
    })
  }

  createMessage() {
    const dialogRef = this.dialog.open(CreateMessageDialogComponent, {
      data: {
        type: 'clientNfs',
        id: this.projectId
      },
      disableClose: true,
      panelClass: 'project-activity-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result[0] === 'success') {
        this.getMessages();
      }
    });
  }

  deleteMsg(msgId: number) {
    const msgIndex = this.clientNfs.findIndex(msg => msg.id === msgId);

    if (msgIndex > -1) {
      this.clientNfs.splice(msgIndex, 1);
    }
  }

  returnZero() {
    return 0
  }

  ngOnDestroy() {

  }


}
